import LinkDownloadApp from './LinkDownloadAppContainer';
export default LinkDownloadApp;
